import React, { useState } from 'react';
import { Button, IconHeader } from '../../../../../components';
import { FormFilter, useFormContext } from '../../../../../features/auto-form';
import { useTranslate } from "../../../../../features/translation/hooks/use-translation"
import FILTER_ATMOSPHERE_OPTIONS from '../data/filter-atmosphere-options.json';
import FILTER_LOCATION_OPTIONS from '../data/filter-location-options.json';
import FILTER_FACILITIES_OPTIONS from '../data/filter-facilities-options.json';
import FILTER_BOARD_OPTIONS from '../data/filter-board-options.json';
import FILTER_ROOM_STYLE_OPTIONS from '../data/filter-room-style-options.json';


const AccommodationFilter = (props) => {
    
    const { t } = useTranslate();

    const [filters, setFilters] = useState({
        atmosphere: [],
        location: [],
        facilities: [],
        board: [],
        roomStyle: []
    });

    const { getRefValue, setRefValue, resetRefValue } = useFormContext();

const onChange = () => {
  const rawFilters = {
    atmosphere: getRefValue('request.accommodation.filter.atmosphere'),
    location: getRefValue('request.accommodation.filter.location'),
    facilities: getRefValue('request.accommodation.filter.facilities'),
    board: getRefValue('request.accommodation.filter.board'),
    roomStyle: getRefValue('request.accommodation.filter.roomStyles')
  };

  const translatedFilters = Object.fromEntries(
    Object.entries(rawFilters).map(([key, values]) => [
      key,
      values.map(value =>
        t(`form.accommodationPreferences.accommodationFilter.${key}.options.${value}`)
      )
    ])
  );

  setFilters(translatedFilters);
};

    const reset = () => {
        resetRefValue('request.accommodation.filter.atmosphere')
        resetRefValue('request.accommodation.filter.location')
        resetRefValue('request.accommodation.filter.facilities')
        resetRefValue('request.accommodation.filter.board')
        resetRefValue('request.accommodation.filter.roomStyles')
        setFilters({
            atmosphere: [],
            location: [],
            facilities: [],
            board: [],
            roomStyle: []
        })
    }

    const removeFilter = (type, value) => {
        const newFilter = filters[type].filter(filter => filter !== value)
        setRefValue(`request.accommodation.filter.${type}`, newFilter)
        let temp = { ...filters }
        temp[type] = newFilter
        setFilters(temp)
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col col-12">
                    <IconHeader title={t("form.accommodationPreferences.accommodationFilter.title")} icon="filter" />
                </div>
            </div>
            <div className="row">
                <div className='col col-12'>
                    <div 
                    className="text base"
                    dangerouslySetInnerHTML={{ __html: t("form.accommodationPreferences.accommodationFilter.description") }} />
                </div>
            </div>
            <div className="row">
                <div className="col col-12" style={{ display: "flex", gap: "var(--space-2)", flex: "1", flexWrap: "wrap" }}>
                    <div  className="filter-col" style={{flexGrow:"1"}} >
                        <FormFilter
                            name="request.accommodation.filter.atmosphere"
                            label={t("form.accommodationPreferences.accommodationFilter.atmosphere.label")}
                            icon="wellness"
                            languagesection="form.accommodationPreferences.accommodationFilter.atmosphere"
                            options={FILTER_ATMOSPHERE_OPTIONS}
                            onChange={onChange}
                        />
                    </div>
                    <div className="filter-col" style={{flexGrow:"1"}}>
                        <FormFilter
                            name="request.accommodation.filter.location"
                            label={t("form.accommodationPreferences.accommodationFilter.location.label")}
                            icon="location-map"
                            languagesection="form.accommodationPreferences.accommodationFilter.location"
                            options={FILTER_LOCATION_OPTIONS}
                            onChange={onChange}

                        />
                    </div>
                    <div className="filter-col" style={{flexGrow:"1"}}>
                        <FormFilter
                            name="request.accommodation.filter.facilities"
                            icon="swimming-pool"
                            label={t("form.accommodationPreferences.accommodationFilter.facilities.label")}
                            languagesection="form.accommodationPreferences.accommodationFilter.facilities"
                            options={FILTER_FACILITIES_OPTIONS}
                            onChange={onChange}

                        />
                    </div>
                    <div className="filter-col" style={{flexGrow:"1"}}>
                        <FormFilter
                            name="request.accommodation.filter.board"
                            label={t("form.accommodationPreferences.accommodationFilter.board.label")}
                            icon="eat"
                            languagesection="form.accommodationPreferences.accommodationFilter.board"
                            options={FILTER_BOARD_OPTIONS}
                            onChange={onChange}

                        />
                    </div>
                    <div className="filter-col" style={{flexGrow:"1"}}>
                        <FormFilter
                            name="request.accommodation.filter.roomStyles"
                            label="Room style"
                            icon="bed"
                            languagesection="form.accommodationPreferences.accommodationFilter.roomStyle"
                            options={FILTER_ROOM_STYLE_OPTIONS}
                            onChange={onChange}

                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col col-12" style={{ display: "flex", flexWrap: "wrap", gap: " var(--space-2)", minHeight: "var(--space-10)" }}>
                    {filters.atmosphere.map(filter => <Button label={filter} className="primary" trailingIcon="cross" onClick={() => removeFilter('atmosphere', filter)} />)}
                    {filters.location.map(filter => <Button label={filter} className="primary" trailingIcon="cross" onClick={() => removeFilter('location', filter)} />)}
                    {filters.facilities.map(filter => <Button label={filter} className="primary" trailingIcon="cross" onClick={() => removeFilter('facilities', filter)} />)}
                    {filters.board.map(filter => <Button label={filter} className="primary" trailingIcon="cross" onClick={() => removeFilter('board', filter)} />)}
                    {filters.roomStyle.map(filter => <Button label={filter} className="primary" trailingIcon="cross" onClick={() => removeFilter('roomStyle', filter)} />)}
                </div>
            </div>
            <div className='row'>
            <div className="col col-12" style={{ display: "flex", paddingRight: "var(--space-2)", justifyContent:"flex-end"}}>
                    {    filters.atmosphere.length > 0 
                        || filters.location.length > 0 
                        || filters.facilities.length > 0
                        || filters.board.length > 0
                        || filters.roomStyle.length > 0
                     ? 
                    
                    <Button label={t("input.button.resetFilter")} className="ghost small" style={{ border: 0, textDecoration: "underline" }} onClick={reset} />
                        : ''}
                    </div>
            </div>
        </div>
    )

};

export default AccommodationFilter;